import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import CoreuiVue from '@coreui/vue-pro'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import DocsCallout from '@/components/DocsCallout'
import DocsExample from '@/components/DocsExample'
import vue3GoogleLogin from 'vue3-google-login'
import VueAppleLogin from 'vue-apple-login'
import { globalVar } from './helper/global.js'

const app = createApp(App)
app.config.globalProperties.$globalVar = globalVar;
app.use(store)

// Dispatch the login action
await store.dispatch('getTLDAndLanguage', {
    url: location.href
});

app.use(router)
app.use(CoreuiVue)
app.provide('icons', icons)
app.component('CIcon', CIcon)
app.component('DocsCallout', DocsCallout)
app.component('DocsExample', DocsExample)
app.use(vue3GoogleLogin, {
    clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
    popupType: 'TOKEN'
})
app.use(VueAppleLogin, {
    clientId: process.env.VUE_APP_APPLE_CLIENT_ID,
    scope: 'name email',
    redirectURI: process.env.VUE_APP_APPLE_REDIRECT_URL + "/" + store.state.tldString,
    state: Date.now().toString(),
    usePopup: false,
})

app.mount('#app')
